import { Mapper } from "../../../../base/utils/mapper";
import { UserRecaptchaValidateModel } from "../../../../domain/models/user/user-recaptcha-validate.model";
import { UserRecaptchaValidateEntity } from "../entities/user-recaptcha-validate.entity";


export class UserValidateRecaptchaImplementationRepositoryMapper extends Mapper<UserRecaptchaValidateEntity, UserRecaptchaValidateModel> {
    mapFrom(param: UserRecaptchaValidateEntity): UserRecaptchaValidateModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: UserRecaptchaValidateModel): UserRecaptchaValidateEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}